module.exports = __webpack_public_path__ + "img/KN.6a4ba1c8.png";